import { Button } from 'antd';
import React, { useState } from 'react';
import { Link } from 'react-router-dom';

import {
  RenewStatusEnum,
  RenewAssignmentEnum,
  AssignmentStatusTypeEnum,
} from 'api/backofficeApiClient';
import {
  AssignmentDetailsModel,
  isEndDateCorrectForRenew,
} from 'utils/assignmentUtils';
import RenewalTypeModal from './RenewalTypeModal';
import { AssignmentInfoTypes } from 'features/assignment/enums';
import { isAdminSelector } from 'redux/selectors/authenticationSelectors';
import { useAppSelector } from 'hooks/useAppSelector';

type Props = {
  loadAssignmentDetails: () => Promise<void>;
  assignmentDetails: AssignmentDetailsModel;
};

export default function RenewAssignment(props: Props) {
  const { assignmentDetails, loadAssignmentDetails } = props;
  const isAdminRole = useAppSelector(isAdminSelector);
  const [isRenewTypeModalVisible, setisRenewTypeModalVisible] = useState(false);
  const {
    assignmentId,
    renewStatus,
    renewType,
    assignmentStatus,
    assignmentDocument,
    childAssignmentKey,
  } = assignmentDetails;

  if (!assignmentDocument) return null;

  const handleOpenRenewTypeModal = () => {
    setisRenewTypeModalVisible(true);
  };

  const handleCloseRenewTypeModal = () => {
    setisRenewTypeModalVisible(false);
  };

  const { assignmentInfo } = assignmentDocument;

  return (
    <>
      {isRenewTypeModalVisible && (
        <RenewalTypeModal
          onSubmit={loadAssignmentDetails}
          assignmentId={assignmentId as string}
          onClose={handleCloseRenewTypeModal}
        />
      )}

      {renewStatus === RenewStatusEnum.ParentRenewRequest && (
        <Link
          className="card-link page-status"
          to={`/assignment/${childAssignmentKey}?section=${AssignmentInfoTypes.Primary}`}
        >
          <span className="icon icon-attention-filled" />
          Renewal request sent
        </Link>
      )}

      {renewStatus === RenewStatusEnum.RenewRequest && (
        <>
          {renewType === RenewAssignmentEnum.WithChanges && (
            <div className="page-status">
              <span className="icon icon-exchange-status" />
              Renewed with changes
            </div>
          )}

          {renewType === RenewAssignmentEnum.WithoutChanges && (
            <div className="page-status">
              <span className="icon icon-exchange-status" />
              Renewed without changes, except for dates of assignment
            </div>
          )}
        </>
      )}

      {!isAdminRole &&
        (assignmentStatus === AssignmentStatusTypeEnum.Active ||
          assignmentStatus === AssignmentStatusTypeEnum.Completed) &&
        isEndDateCorrectForRenew(assignmentInfo?.endDate) &&
        renewStatus !== RenewStatusEnum.ParentRenewRequest && (
          <div>
            <Button onClick={handleOpenRenewTypeModal}>Renew assignment</Button>
          </div>
        )}
    </>
  );
}
